import { InitialFormValues } from '@/utils';
import { SetStateAction, createContext, useContext, ReactNode, useState, Dispatch, FC } from 'react';

type ApplicationContextType = {
  setInitialValues: Dispatch<SetStateAction<Partial<InitialFormValues>>>;
  setIsFromJourneyPages: Dispatch<SetStateAction<boolean>>;
  initialValues: Partial<InitialFormValues>;
  isFromJourneyPages: boolean;
};

type ApplicationProviderType = {
  children: ReactNode;
};

const ApplicationContext = createContext<ApplicationContextType>({
  setIsFromJourneyPages: () => false,
  setInitialValues: () => {},
  isFromJourneyPages: false,
  initialValues: {},
});

export const ApplicationFormContextProvider: FC<ApplicationProviderType> = ({ children }) => {
  const [initialValues, setInitialValues] = useState<Partial<InitialFormValues>>({});
  const [isFromJourneyPages, setIsFromJourneyPages] = useState(false);

  return (
    <ApplicationContext.Provider
      value={{
        setIsFromJourneyPages,
        isFromJourneyPages,
        setInitialValues,
        initialValues,
      }}
    >
      {children}
    </ApplicationContext.Provider>
  );
};

export const useApplicationContext = (): ApplicationContextType => useContext(ApplicationContext);
